import { Api, apiMixin, ConfigHelper, createApiService } from 'relapp-api';
import store from '@/store/index.js';

export default {
    ...createApiService('services'),
    /**
     * Call the cancel service endpoint.
     *
     * @param {object} form
     *
     * @return {Promise}
     */
    cancel({ form }) {
        const route = ConfigHelper.apiUrl('services.cancel');

        return Api.post(route, form.data())
            .then(response => {
                store.dispatch('services/updateItems', response.data.data);
            })
            .catch(apiMixin.methods.handleError);
    },
    /**
     * Send the changed customer of the service to the endpoint.
     *
     * @param {string} domain
     * @param {string} data
     *
     * @return {Promise}
     */
    changeCustomer({ domain, data }) {
        const route = ConfigHelper.apiUrl('services.customer.put', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.put(route, data);
    }

    // /**
    //  * Send the changed customer of the service to the endpoint.
    //  *
    //  * @param {string} product
    //  *
    //  * @return {Promise}
    //  */
    // accessProduct({ product }) {
    //     const accessibles = ConfigHelper.apiUrl('modules-enabled.current')
    //
    //     return Api.put(route, data);
    // }
};
